import { useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase/config';
import { identify } from './analytics';

export function useIdentify() {
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      identify(user ? user.uid : null);
    });
    return unsub;
  }, []);
}

export default function IdentifyUser() {
  useIdentify();
  return null;
}
